import { ListPage } from '@components/molecules';
import { TextFieldElement } from 'react-hook-form-mui';
import API from '@apps/localization/services/city';
import { ModelProps } from '@/types';
import { CitySchema, CitySearchSchema } from '@apps/localization/schemas/city';
import { GridColDef } from '@mui/x-data-grid';
import { JSX } from 'react';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { YesNoAutocompleteElement } from '@/components/atoms';
import AsyncAutocompleteElement from '@/components/atoms/asyncautocomplete';
import CountryAPI from '@apps/localization/services/country';

export default function ObjectListPage(modelProps: ModelProps): JSX.Element {
  const { t } = useTranslation();
  const columns: GridColDef[] = [
    {
      field: 'name',
      headerName: t('Name'),
      flex: 1,
    },
    {
      field: 'country',
      headerName: t('Country'),
      width: 250,
      valueFormatter: (params: { id: number; label: string }) => {
        return params.label;
      },
    },
    {
      field: 'timezone',
      headerName: t('Timezone'),
      width: 250,
      valueFormatter: (params: { id: number; label: string }) => {
        return params.label;
      },
    },
    {
      field: 'is_active',
      headerName: t('Is Active?'),
      width: 120,
      type: 'boolean',
    },
  ];

  return (
    <ListPage
      schema={CitySchema}
      schemaSearch={CitySearchSchema}
      title={t('City')}
      api={API}
      columns={columns}
      modelProps={modelProps}
      initialState={{
        sorting: {
          sortModel: [{ field: 'name', sort: 'asc' }],
        },
      }}
    >
      <Grid size={{ xs: 12, md: 3 }}>
        <TextFieldElement name="search" label={t('Search')} fullWidth />
      </Grid>
      <Grid size={{ xs: 12, md: 3 }}>
        <AsyncAutocompleteElement
          api={CountryAPI.select}
          name="country"
          label={t('Country')}
          required
        />
      </Grid>
      <Grid size={{ xs: 12, md: 3 }}>
        <YesNoAutocompleteElement name="is_active" label={t('Is Active?')} />
      </Grid>
    </ListPage>
  );
}
